<template>
<span>
    <v-btn
        color="primary"
        class="ma-2"
        @click="capturePicture()"
        >
        <v-icon
        class="mx-2"
        dark
        >
        mdi-camera
        </v-icon>        
        {{$t("uploader.uploadImageCamera")}}
    </v-btn> 
</span>
</template>

<script>
import pictureManager from "../../common/PictureManager";
import api from "../../../api/flexiapp";

import cordova from "../../../api/cordova";

  export default {
    name: 'CameraPictureUploader', 
    props: ['prependIcon','workorderId','lineId','assembleStepId'],
    data(){
        return {  
        }

    },  
    updated: function() {
            
    },
    computed: {
    },
    methods: {
        processCameraCapture: function (base64Capture) {
            const base64String = base64Capture.replace('data:', '').replace(/^.+,/, '');                      

            const me = this;
            var data ={
                            workorderId: me.workorderId,
                            lineId: me.lineId,
                            "assembleStepId":  me.assembleStepId,
                        };

                        //almacenamos datos imagen
                        api.postPicture(
                            data.workorderId,
                            data.lineId,
                            data,
                            function () {
                                data.image = base64String;

                                //planificamos subida binario imagen
                                pictureManager.addPicture(data);
                                me.$emit('pic-uploaded');
                            },
                            function (error) {
                                window.$vue.$log.error(error);

                                data.image = base64String;

                                //planificamos subida binario imagen
                                pictureManager.addPicture(data);                                    
                            }
                        );
        },
        capturePicture: function () {
            window.$vue.$off('camera:capture');
            window.$vue.$on('camera:capture', this.processCameraCapture);
            cordova.sendCapturePicture();
        },
        
      },
      mounted: function() {
        window.$vue.$off('connection:type');
        window.$vue.$on('connection:type', pictureManager.processNetworkUpdate);
        window.$vue.$off('ne_awake');
        window.$vue.$on('ne_awake', pictureManager.processAwake);
   },
  }
</script>